<div class='left-menu'>
  <ul class='nav navbar-nav'>
    <li [routerLinkActive]="['link-active']">
      <a class='menu-callback' (click)="onReload.emit()" title="Refresh">
        <span class='glyphicon glyphicon-refresh'></span> Refresh
      </a>
    </li>
    <li [routerLinkActive]="['link-active']">
      <a class='menu-callback' target="_blank" (click)="openDocumentationModal()" title="Wiki">
        <span class='glyphicon glyphicon-info-sign'></span> Documentation
      </a>
    </li>
    <li class="separator"></li>
    <li class="submenu-title">
      <h4>Excel</h4>
    </li>
    <li [routerLinkActive]="['link-active']">
      <a class='menu-callback' target="_blank" (click)="outputDownload.emit(this.currentType)" title="Download">
        <span class='glyphicon glyphicon-download'></span> Download
      </a>
    </li>
    @if (!defaults.isReadonlyUser) {
      <li [routerLinkActive]="['link-active']">
        <a class='menu-callback' title="Upload" (click)="onUpload()">
          <span class='glyphicon glyphicon-upload'></span> Upload
        </a>
      </li>
    }
    @if (defaults.stage !== 2) {
      <li class="separator"></li>
      <li class="submenu-title">
        <h4>Web Services</h4>
      </li>
      @if (!defaults.isReadonlyUser) {
        <li [routerLinkActive]="['link-active']">
          <a class='menu-callback' title="" (click)="openAzureDataFactoryTriggerModal(false)">
            <span class='glyphicon glyphicon-play'></span> Trigger
          </a>
        </li>
      }
      <li [routerLinkActive]="['link-active']" (click)="showLastCustomerDocumentsRuns()">
        <a class='menu-callback' title="">
          <span class='glyphicon glyphicon-list'></span> Last Runs
        </a>
      </li>
    }
    <li class="separator" [ngClass]="saveService.classSaveButton"></li>
    <li [routerLinkActive]="['link-active']" [ngClass]="saveService.classSaveButton">
      <a class='menu-callback' (click)="saveService.fireSave()" title="Save">
        <span class='glyphicon glyphicon-floppy-disk'></span> Save
      </a>
    </li>
  </ul>
</div>